import React from 'react';
import { without, findIndex, omitBy, isNil } from 'lodash';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import RelatedUrlsTableRow from './RelatedUrlsTableRow';
import LoadingTable from './LoadingTable';
import RelatedUrlsBlankSlate from './RelatedUrlsBlankSlate';

class RelatedUrlsTableBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      relatedUrls: null,
      learningContent: null,
    };
    this.fetchData = this.fetchData.bind(this);
    this.fetchAssignables = this.fetchAssignables.bind(this);
    this.saveNewRow = this.saveNewRow.bind(this);
    this.deleteRelatedUrl = this.deleteRelatedUrl.bind(this);
    this.updateRelatedUrl = this.updateRelatedUrl.bind(this);
  }

  fetchData() {
    request.get(this.props.path).then(payload => {
      this.setState({
        loading: false,
        relatedUrls: payload.relatedUrls,
      });
    });
  }

  fetchAssignables() {
    request
      .get(routes.ASSIGNABLES.CONTENT, { per_page: 9999 })
      .then(payload => {
        this.setState({
          learningContent: payload.data,
        });
      });
  }

  saveNewRow(relatedUrl) {
    this.setState(state => ({
      relatedUrls: [relatedUrl, ...state.relatedUrls],
    }));
  }

  deleteRelatedUrl(deletedUrl) {
    // eslint-disable-next-line no-alert
    if (window.confirm(this.props.i18n.delete_url)) {
      request.delete(this.props.path + '/' + deletedUrl.id).then(data => {
        if (deletedUrl.url) {
          lly.relatedUrls.remove(deletedUrl);
        } else if (deletedUrl.name) {
          lly.relatedKeywords.remove(deletedUrl);
        }
        this.setState(state => ({
          relatedUrls: without(state.relatedUrls, deletedUrl),
        }));
      });
    }
  }

  updateRelatedUrl(relatedUrl) {
    return new Promise((resolve, reject) => {
      request
        .put(this.props.path + '/' + relatedUrl.id, omitBy(relatedUrl, isNil))
        .then(data => {
          const { relatedUrls } = this.state;
          const index = findIndex(relatedUrls, ['id', relatedUrl.id]);
          const updatedRelatedUrlsArray = [
            ...relatedUrls.slice(0, index),
            data,
            ...relatedUrls.slice(index + 1),
          ];
          this.setState({
            relatedUrls: updatedRelatedUrlsArray,
          });
          resolve(data);
        })
        .fail(data => {
          reject(data.responseJSON);
        });
    });
  }

  componentDidMount() {
    this.fetchData();
    this.fetchAssignables();
  }

  render() {
    const newRelatedUrl = {
      id: null,
      [this.props.param]: null,
      matchType: 'exact',
      mappings: [],
    };

    return (
      <div>
        {this.state.loading && <LoadingTable />}
        {!this.state.loading &&
          this.state.relatedUrls.length === 0 &&
          !this.props.newMappingFormVisible && (
            <RelatedUrlsBlankSlate
              i18n={this.props.i18n}
              showNewMappingForm={this.props.showNewMappingForm}
            />
          )}
        {!this.state.loading && (
          <div className="RelatedUrlsTableBody FlexboxTable-body">
            {this.props.newMappingFormVisible && (
              <RelatedUrlsTableRow
                hideNewMappingForm={this.props.hideNewMappingForm}
                relatedUrl={newRelatedUrl}
                i18n={this.props.i18n}
                types={this.props.types}
                path={this.props.path}
                param={this.props.param}
                features={this.props.features}
                editing
                saveNewRow={this.saveNewRow}
                learningContent={this.state.learningContent}
              />
            )}
            {this.state.relatedUrls.map(relatedUrl => (
              <RelatedUrlsTableRow
                updateUrlErrorMessage={this.state.errorMessage}
                relatedUrl={relatedUrl}
                i18n={this.props.i18n}
                types={this.props.types}
                path={this.props.path}
                param={this.props.param}
                features={this.props.features}
                key={relatedUrl.id}
                deleteRelatedUrl={this.deleteRelatedUrl}
                saveNewRow={this.saveNewRow}
                updateRelatedUrl={this.updateRelatedUrl}
                learningContent={this.state.learningContent}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default RelatedUrlsTableBody;
